<!-- Contenedor estrecho para vistas de Padre / Estudiante -->
<div *ngIf="rol !== 'ADMIN'" class="px-6 py-8 mx-auto w-full max-w-5xl">
    <app-dashboard-padre *ngIf="rol === 'PADRE'" />
    <app-dashboard-estudiante *ngIf="rol === 'ESTUDIANTE'" />
    <!-- <app-dashboard-docente *ngIf="rol === 'DOCENTE'" /> -->
</div>

<!-- Contenedor ancho para vista Admin / Directivo -->
<div *ngIf="rol === 'ADMIN'" class="px-4 py-4 w-full">
    <app-dashboard-admin />
</div>